import ShelfPlaceholder from './ShelfPlaceholder'

export default ShelfPlaceholder
// eslint-disable-next-line import/export
export * from './ShelfPlaceholder'
